module.exports = __webpack_public_path__ + "img/emoji_163.b44230a3.png";